<script>
  import { createEventDispatcher } from "svelte";
  import { currentLanguage } from "../store";
  import translations from "../translations";
  import { normalizeUrlFieldValue } from "../utils/utilities";

  const dispatch = createEventDispatcher();

  export let data;
  export let item;
  export let value;
  export let index;
  export let validateKey;
  export let allItems;

  let currentLang = "en"; // Default language
  // Subscribe to changes in currentLanguage
  currentLanguage.subscribe((value) => {
    currentLang = value;
  });

  let isError = false;
  let err = "";

  const fileValidate = (file) => {
    if (file.size > 5368709120 || !["pdf", "docx", "xlsx", "jpg", "jpeg", "png", "zip"].includes(file.name.split(".").pop().toLowerCase())) {
      return false;
    }

    return true;
  };

  const buildRegExp = (rawPattern) => {
    if (!rawPattern || typeof rawPattern !== "string") return null;
    const match = rawPattern.match(/^\/(.+)\/([gimsuy]*)$/);
    try {
      return match ? new RegExp(match[1], match[2].replace("g", "")) : new RegExp(rawPattern);
    } catch (_) {
      return null;
    }
  };

  const getRegularExpressionValidationText = () => {
    if (data.regularExpressionValidationText) return data.regularExpressionValidationText;
    return translations.regularExpressionValidationText[currentLang] ?? translations.regularExpressionValidationText.en;
  };

  export const setServerError = (message) => {
    isError = true;
    err = message;
    if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
    dispatch("error", true);
  };

  export const validate = () => {
    if (item.val === undefined) item.val = "";
    if (item.type === "url") item.val = normalizeUrlFieldValue(item.val);
    if (item.type === "selectBooking") {
      let hasError = false;

      if (item.required) {
        // Validate the select field
        if (!item.selectVal || item.selectVal === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.bookingCategoryRequiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }

        // Validate the date field
        if (!item.dateVal || item.dateVal === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.bookingDateRequiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }
      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else if (item.type === "selectBookingFullDay") {
      let hasError = false;

      if (item.required) {
        // Validate the select field
        if (!item.selectVal || item.selectVal === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.bookingCategoryRequiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }

        if (!item.startDateVal || item.startDateVal === "" || !item.endDateVal || item.endDateVal === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.bookingDateRangeRequiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }
      // Validar el rango de días entre startDateVal y endDateVal
      if (item.minDuration || item.maxDuration) {
        const startDate = new Date(item.startDateVal);
        const endDate = new Date(item.endDateVal);
        const diffTime = endDate - startDate;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Diferencia en días

        if (item.minDuration && diffDays < item.minDuration) {
          err = data.minDurationValidationText
            ? data.minDurationValidationText
            : translations.minDurationValidationText[currentLang].replace("{min}", item.minDuration);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
        if (item.maxDuration && diffDays > item.maxDuration) {
          err = data.maxDurationValidationText
            ? data.maxDurationValidationText
            : translations.maxDurationValidationText[currentLang].replace("{max}", item.maxDuration);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else if (item.type === "selectBookingAdvanced") {
      let hasError = false;
      err = "";

      // Advanced bookings always require a category, regardless of the field configuration.
      if (!item.selectVal || item.selectVal === "") {
        err = data.requiredValidationText ? data.requiredValidationText : translations.bookingCategoryRequiredValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
        hasError = true;
      }

      // Validate the min and max amount for the selected item
      let selectedOption = item.dataObject.find((option) => option.value === item.selectVal);
      if (selectedOption) {
        if (selectedOption.canMultiplyMin && item.amount < selectedOption.canMultiplyMin) {
          err += data.minAmountValidationText
            ? data.minAmountValidationText
            : translations.minAmountValidationText[currentLang].replace("{min}", selectedOption.canMultiplyMin);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
        if (selectedOption.canMultiplyMax && item.amount > selectedOption.canMultiplyMax) {
          err += data.maxAmountValidationText
            ? data.maxAmountValidationText
            : translations.maxAmountValidationText[currentLang].replace("{max}", selectedOption.canMultiplyMax);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else if (item.type === "selectAndPrice") {
      let hasError = false;
      err = "";

      if (item.required) {
        // Validate the select field
        if (!item.val || item.val === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      // Validate the min and max amount for the selected item
      let selectedOption = item.dataObject.find((option) => option.value === item.val);
      if (selectedOption) {
        if (selectedOption.canMultiplyMin && item.amount < selectedOption.canMultiplyMin) {
          err += data.minAmountValidationText
            ? data.minAmountValidationText
            : translations.minAmountValidationText[currentLang].replace("{min}", selectedOption.canMultiplyMin);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
        if (selectedOption.canMultiplyMax && item.amount > selectedOption.canMultiplyMax) {
          err += data.maxAmountValidationText
            ? data.maxAmountValidationText
            : translations.maxAmountValidationText[currentLang].replace("{max}", selectedOption.canMultiplyMax);
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else if (item.type === "number" || item.type === "price") {
      let hasError = false;
      if (item.required) {
        if (!item.val || item.val === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      // Validate the value is a number
      const numericPattern = item.type === "price" ? /^\d+(?:[.,]\d+)?$/ : /^\d+$/;
      if (item.val && item.val !== "" && !numericPattern.test(item.val)) {
        err = data.numberValidationText ? data.numberValidationText : translations.numberValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
        hasError = true;
      }

      // Validate min and max values
      if (item.min && item.val < item.min) {
        err = data.minNumberValidationText
          ? data.minNumberValidationText
          : translations.minNumberValidationText[currentLang].replace("{min}", item.min);
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
        hasError = true;
      }

      if (item.max && item.val > item.max) {
        err = data.maxNumberValidationText
          ? data.maxNumberValidationText
          : translations.maxNumberValidationText[currentLang].replace("{max}", item.max);
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
        hasError = true;
      }

      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else if (item.type === "date" && (item.subtype === "pickUpDate" || item.subtype === "dropOffDate")) {
      let hasError = false;

      if (item.required) {
        if (!item.val || item.val === "") {
          err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
          hasError = true;
        }
      }

      // Validate the date is in the future
      if (item.val && new Date(item.val) < new Date()) {
        err = data.dateBeforeTodayValidationText ? data.dateBeforeTodayValidationText : translations.dateBeforeTodayValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
        hasError = true;
      }

      // Validate the drop-off date is before the pick-up date
      if (item.subtype === "pickUpDate") {
        const dropOffItem = allItems.find((i) => i.subtype === "dropOffDate" && i.type === "date" && i.val);
        if (dropOffItem) {
          const pickUpDate = new Date(item.val);
          const dropOffDate = new Date(dropOffItem.val);
          if (pickUpDate < dropOffDate) {
            err = data.dropOffBeforePickUpValidationText
              ? data.dropOffBeforePickUpValidationText
              : translations.dropOffBeforePickUpValidationText[currentLang] ?? "La fecha de recogida debe ser posterior a la de entrega.";
            if (value.findIndex((c) => c.index === index) === -1) value.push({ index });
            isError = true;
            hasError = true;
          }
        }
      } else if (item.subtype === "dropOffDate") {
        const pickUpItem = allItems.find((i) => i.subtype === "pickUpDate" && i.type === "date" && i.val);
        if (pickUpItem) {
          const dropOffDate = new Date(item.val);
          const pickUpDate = new Date(pickUpItem.val);
          if (dropOffDate > pickUpDate) {
            err = data.pickUpBeforeDropOffValidationText
              ? data.pickUpBeforeDropOffValidationText
              : translations.pickUpBeforeDropOffValidationText[currentLang] ?? "La fecha de entrega debe ser anterior a la de recogida.";
            if (value.findIndex((c) => c.index === index) === -1) value.push({ index });
            isError = true;
            hasError = true;
          }
        }
      }

      if (!hasError) {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    } else {
      if (
        item.required &&
        item.type !== "hidden2" &&
        item.type !== "hidden" &&
        item.type !== "freetext" &&
        (item.val === "" || item.val === false || (item.type == "tel" && item.telNum === ""))
      ) {
        err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (
        (item.type === "number" || item.type === "price") &&
        item.val !== "" &&
        !(item.type === "price" ? /^\d+(?:[.,]\d+)?$/ : /^\d+$/).test(item.val)
      ) {
        err = data.numberValidationText ? data.numberValidationText : translations.numberValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (
        item.type === "url" &&
        item.val !== "" &&
        !/(http(s)?:\/\/)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(item.val)
      ) {
        err = data.urlValidationText ? data.urlValidationText : translations.urlValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (
        item.type === "tel" &&
        item.telNum !== "" &&
        (!/^\d{6,15}$/.test(item.telNum) ||
          (item.telCode === "34" && !/^[6-8]\d{8}$/.test(item.telNum) && !/^[9]\d{8,9}$/.test(item.telNum)) ||
          (item.maxLength && item.telNum.length !== Number(item.maxLength)))
      ) {
        err = data.telValidationText ? data.telValidationText : translations.telValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (item.type === "email" && item.val !== "" && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,11})+$/.test(item.val)) {
        err = data.emailValidationText ? data.emailValidationText : translations.emailValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (item.type === "file" && !fileValidate(item.val)) {
        err = data.fileValidationText ? data.fileValidationText : translations.fileValidationText[currentLang];
        if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
        isError = true;
      } else if (item.type === "text" && item.subtype === "regularExpression" && item.val !== "" && item.validation) {
        const regExp = buildRegExp(item.validation);

        if (!regExp || !regExp.test(item.val)) {
          err = getRegularExpressionValidationText();
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
        } else {
          if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
          isError = false;
        }
      } else if (item.type === "zipcode" && item.val !== "" && item.validation) {
        const regExp = buildRegExp(item.validation);

        if (!regExp || !regExp.test(item.val)) {
          err = data.zipcodeValidationText ? data.zipcodeValidationText : translations.zipcodeValidationText[currentLang];
          if (value.findIndex((c) => c.index === index) === -1) value.push({ index: index });
          isError = true;
        } else {
          if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
          isError = false;
        }
      } else {
        if (value.findIndex((c) => c.index === index) > -1) value.splice(value.findIndex((c) => c.index === index));
        isError = false;
      }
    }

    dispatch("error", isError);
  };
</script>

{#if isError}
  <div class="chatwith-error-text">
    {err}
  </div>
{/if}

<style>
  .chatwith-error-text {
    padding: 3px;
    color: #ff8076;
    font-weight: bold;
    font-size: 10pt;
    margin-top: 3px;
    border-radius: 5px;
    text-align: left;
  }
</style>
